module.exports = __webpack_public_path__ + "img/loginLeft.5d206ddc.gif";